module.exports = __webpack_public_path__ + "static/img/bak04.8a3500a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/bak04.jpeg
// module id = H8m+
// module chunks = 1